// @flow
import React from 'react';
import ShippingTrackingContainer from 'containers/ShippingTrackingContainer';

const ShippingTracking = ({ match, location }: any) => {
  return <ShippingTrackingContainer match={match} location={location} />;
};

export default ShippingTracking;



// WEBPACK FOOTER //
// ./src/pages/ShippingTracking.js